import EntityListTemplate from '../../templates/EntityListTemplate'

const HollometersListPage = () => {
  return (
    <EntityListTemplate
      entityName="stations"
      defaultSort={[]}
      defaultFilters={{ items: [] }}
      fetchWithMeta={true}
    />
  )
}

export default HollometersListPage
